<template>
  <div>
    <div class="text-center" style="height: 100vh; width:100vw">
      <mdb-btn @click="capture = !capture" >{{ capture===true?"Start" : "Stop"}}</mdb-btn>

      <card-capture-new v-if="capture"></card-capture-new>
    </div>

  </div>
</template>
<script>


import axios from "axios";
import CardCaptureNew from "@/components/CardCaptureNew";

export default {
  name: "About",
  components: {
    CardCaptureNew
  },
  data() {
    return {
      capture:false
    }
  },
  mounted() {

  },

}
</script>
<style scoped>

</style>
